import React, { useState } from "react";
import { Grid, Tab, Typography, Box, Tabs } from "@mui/material";
import { useSelector } from "react-redux";
import SimulationTable from "../simulations/SimulationTable";
import SimulationCollectionTable from "../sim-collections/SimulationCollectionTable";
import MainCard from "../../components/cards/MainCard";
import { useGetFeatureSwitchesQuery } from "../../store/services/tenancy.service"; // Add this import
import { useLocation, useNavigate } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simulation-overview-tabpanel-${index}`}
            aria-labelledby={`simulation-overview-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simulation-overview-tab-${index}`,
        'aria-controls': `simulation-overview-tabpanel-${index}`,
    };
}

export default function SimulationOverview() {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);

    const initialTab = parseInt(searchParams.get("tab")) || 0;


    const { tenancyId } = useSelector((state) => state.tenancy);
    const [tabValue, setTabValue] = useState(initialTab);

    // State for selected simulations and collections (if needed for future functionality)
    const [selectedSimulations, setSelectedSimulations] = useState([]);
    const [selectedCollections, setSelectedCollections] = useState([]);

    // Get feature switches for current tenancy
    const {
        data: featureSwitchesApiData,
        isLoading: featureSwitchesLoading
    } = useGetFeatureSwitchesQuery({ tenancyId });

    // Extract actual feature data
    const actualData = featureSwitchesApiData?.data || featureSwitchesApiData;

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        navigate(`?tab=${newValue}`, { replace: true });
    };

    // Define all possible tabs
    const allTabs = [
        {
            label: "Library",
            component: (
                <SimulationTable
                    type="library"
                    simulationIds={selectedSimulations}
                    setSimulationId={setSelectedSimulations}
                />
            )
        },
        {
            label: "Collections",
            component: (
                <SimulationCollectionTable
                    type="edit"
                    collectionIds={selectedCollections}
                    setCollectionId={setSelectedCollections}
                />
            ),
            condition: actualData?.enableRandomSimulation // Add condition for this tab
        }
    ];

    // Filter tabs based on feature switches
    const tabs = allTabs.filter(tab => tab.condition !== false);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            <Grid item xs={12}>
                {/* Tabs */}
                <Box sx={{ mx: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        ariaLabel="simulation overview tabs"
                    >
                        {tabs.map((tab, index) => (
                            <Tab key={index} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                </Box>
                {tabs.map((tab, index) => (
                    <TabPanel key={index} value={tabValue} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Grid>
        </Grid>
    );
}